import React, { Component } from 'react';
import { Icon, Modal, Toast } from "antd-mobile";
import axios from "axios";
import CardList from "./CardList"
import storage from "../model/storage";
import globalSubscribe from "../common/globalState";
const alert = Modal.alert;
class Answersheet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      queNum: 0,
      isSub:false,
      loading:false,
      dataDid:0
    };
    this.SubExam=debounce(this.SubExam, 1000);
    this.sub=debounce(this.sub, 1000);
    
  }
  onOpenChange = () => {
    this.state.loading=true
    if (this.state.open === false) {
      this.randerCard();
    }
    
 this.setState({ open: !this.state.open });
  }

  showAlert = (zhuguan) => {
    alert('试卷已完成', '试卷已全部完成，是否再检查一下？', [
      { text: '取消', onPress: () => console.log('cancel'), style: 'default' },
      { text: '交卷', onPress: () => this.SubExam(zhuguan)}
    ]);

  };
  NoCshow = (zhuguan) => {
    alert('试卷未完成', '试卷还有题目未作答，确认交卷么？', [
      { text: '取消', onPress: () => console.log('cancel'), style: 'default' },
      { text: '交卷', onPress: () =>this.SubExam(zhuguan)}
    ]);

  };
  handleTouchMove = (e) => {

    e.preventDefault();

  }
  sub = () => {
    var that = this;
    // console.log(that.state.ansCardDatas,'console.log(that.state.ansCardDatas)')
    // return false
    if(that.state.isSub === false){
      that.setState({
        isSub:true
      })
      // axios.get(storage.baseUrl + '/checkPaperDegrees', {
      //   params: {
      //     examId: that.props.examId,
      //     paperId: that.props.paperId,
      //     userId: that.props.userId
      //   }
      // })
      axios({
        method:'post',
        headers: {
          'Content-Type': 'application/json',
        },
        url:storage.baseUrl + '/updateAnswerCard', 
        data:that.state.ansCardDatas
      })
        .then(function (response) {
          if (response.data.code === "0000") {
            that.checkExam()
          } else {
            Toast.info(response.msg);
          }
          setTimeout(()=>{
            that.setState({
              isSub:false
            })
          },2000)
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
    }
   



  }
  
  checkExam = () =>{
    var that = this;
    axios.get(storage.baseUrl + '/checkPaperDegrees', {
      params: {
        examId: that.props.examId,
        paperId: that.props.paperId,
        userId: that.props.userId
      }
    }).then(function (response) {
      if (response.data.code !== "0000") {  
        that.NoCshow(response.data.datas.zhuguan)
      } else {
        that.showAlert(response.data.datas.zhuguan)
      }
      setTimeout(()=>{
        that.setState({
          isSub:false
        })
      },2000)
    })
    .catch(function (error) {
      // handle error
      console.log(error);
    })
  }
  SubExam = (zhuguan) => {
    var that = this;
    if(this.props.examType==='1'&&zhuguan/1>0){
      Toast.info('交卷成功,请主观题自评分', 1);
      that.props.history.push({ pathname: "/MkSelf", state: { examId: that.props.examId, paperId: that.props.paperId, userId: that.props.userId } });
    
    }else{
      axios.get(storage.baseUrl + '/referToPaper',
      {
        params: {
          examId: that.props.examId,
          paperId: that.props.paperId,
          userId: that.props.userId
        }
      }
      )
        .then(function (response) {
          
          // if(that.props.examType==='1'&&zhuguan/1>0){
          //   Toast.info('交卷成功,请主观题自评分', 1);
          //   that.props.history.push({ pathname: "/MkSelf", state: { examId: that.props.examId, paperId: that.props.paperId, userId: that.props.userId } });  
          // }else{                   
            Toast.info('交卷成功', 1);
            setTimeout(() => {
              that.props.history.push({ pathname: "/Result", state: { examId: that.props.examId, paperId: that.props.paperId, userId: that.props.userId } });
    
            }, 200); 
          // }

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
    }
    
    

  }
  componentDidMount() {
    // debugger
    this.props.onRef(this)
    this.randerCard();
    // globalSubscribe.on((state, preState) => {
    //   debugger;
    //   console.log(preState.arr, 'preState ++++++++++++++++');
    //   console.log(state.arr, 'state ++++++++++++=');
    //   this.randerCard();
    // })
  }

  randerCard = () => {
    // debugger
    var that = this;
    // let paramsUrl = (this.props.isDid && this.props.isDid === true)?'/showPaper':'/paperACDatas';
    // let paramsData = (this.props.isDid && this.props.isDid === true)?{
    //   examId: that.props.examId,
    //   paperId: that.props.paperId,
    //   userId: that.props.userId
    // }:{
    //   paperId: that.props.paperId,
    //   userId: that.props.userId
    // }
    let paramsUrl = '/paperACDatas';
    let paramsData = {
      paperId: that.props.paperId,
      userId: that.props.userId
    }
    // if (this.props.isDid && this.props.isDid === true) {


      // axios.get(storage.baseUrl + '/showPaper', {
      //   params: {
      //     examId: that.props.examId,
      //     paperId: that.props.paperId,
      //     userId: that.props.userId
      //   }
      // })
      //   .then(function (response) {
          
      //     // handle success
      //     let ansCardDatas = response.data.questionDatas;
      //     that.setState({
      //       ansCardDatas: ansCardDatas
      //      })
      //   })
      //   .catch(function (error) {
      //     // handle error
      //     console.log(error);
      //   })

    // } else {

      axios.get(storage.baseUrl + paramsUrl, {
        params: paramsData
      })
        .then(function (response) {
          // handle success
          //console.log(response);
          // if(that.props.isDid && that.props.isDid === true){
          //   let questionDatas = response.data.questionDatas
          //   that.setState({
          //     ansCardDatas:questionDatas,
          //     loading:false
          //   })
          // }else{
            // globalSubscribe.on((state, preState) => {
            //   console.log(preState.arr, 'preState ++++++++++++++++');
            //   console.log(state.arr, 'state ++++++++++++=');
            // })
            let oldAnsCardDatas = response.data.ansCardDatas;
            let newAnsCardDatas = globalSubscribe.getState().arr
            // console.log(newAnsCardDatas,'newAnsCardDatas')
            let obj = {}; let c = [];
            [].concat(oldAnsCardDatas, newAnsCardDatas).map(o => {
                if (o.optChoose) {
                  o.status = '1';
                }else {
                  o.status = '0';
                }
                // if (obj[o.questionId].status&&obj[o.questionId].status == '1') {
                //   o.status = '1';
                // }
                obj[o.questionId] = o;
              });
              // console.log(obj, 'obj')
              Object.keys(obj).map(key => {
                c.push(obj[key])
              })
            let ansCardDatas = c
            that.setState({
              ansCardDatas:ansCardDatas,
              loading:false
            }, () => {
              // console.log(ansCardDatas, 'ansCardDatas')
            })
          // }
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
    // }
  }
  componentWillReceiveProps() {

  }


  render() {
    return (
      <div className={this.state.open === true ? 'sh_bg' : ''} id="gfCon" onTouchStart={this.handleTouchStart}
        onTouchMove={this.handleTouchMove}
        onTouchEnd={this.handleTouchEnd}
        onTouchCancel={this.handleTouchCancel}>
        <div className={this.state.open === true ? 'sh_con' : 'sh_bot sh_con'}>
          <div onClick={this.onOpenChange} className="sh_title">交卷/答题卡(共{this.state.ansCardDatas&&this.state.ansCardDatas.length}道题）<Icon type={this.state.open === true ? "down" : "up"} /></div>
          <div className="sh_content">
            <div className="sh_top">
              <div className="no_as"><i></i>未作答</div>
              <div className={this.props.isDid === false ? "did_as" : "none"}><i></i>已作答</div>
              <div className={this.props.isDid === false ? "none" : "right_as"}><i></i>正确</div>
              <div className={this.props.isDid === false ? "none" : "err_as"}><i></i>错误</div>
            </div>
            <div className="sh_ques" id="shCon" onTouchMove={this.handleTouchMove}>
              <CardList data={this.state.ansCardDatas} isDid={this.props.isDid} title="题号"></CardList>
              
              {/* {this.state.singleList && <CardList data={this.state.singleList} title="单选题" isDid={this.props.isDid}></CardList>}
              {this.state.multiList && <CardList data={this.state.multiList} title="多选题" isDid={this.props.isDid}></CardList>}
              {this.state.judgeList && <CardList data={this.state.judgeList} title="判断题" isDid={this.props.isDid}></CardList>}
              {this.state.shortList && <CardList data={this.state.shortList} title="简答题" isDid={this.props.isDid}></CardList>}
              {this.state.analysList && <CardList data={this.state.analysList} title="辨析题" isDid={this.props.isDid}></CardList>}
              {this.state.materAnalys && <CardList data={this.state.materAnalys} title="材料分析题" isDid={this.props.isDid}></CardList>}
              {this.state.writings && <CardList data={this.state.writings} title="写作题" isDid={this.props.isDid}></CardList>}
              {this.state.desingns && <CardList data={this.state.desingns} title="教学设计题" isDid={this.props.isDid}></CardList>}
              {this.state.caseAnalys && <CardList data={this.state.caseAnalys} title="案例分析题" isDid={this.props.isDid}></CardList>}
              {this.state.nounExplains && <CardList data={this.state.nounExplains} title="名词解释题" isDid={this.props.isDid}></CardList>}
              {this.state.discussTypes && <CardList data={this.state.discussTypes} title="论述题" isDid={this.props.isDid}></CardList>}
              {this.state.activeDesigns && <CardList data={this.state.activeDesigns} title="活动设计题" isDid={this.props.isDid}></CardList>} */}


            </div>
          </div>
          {!this.props.isDid && <button className="sub_exam" onClick={this.sub}>交卷</button>}
        </div>

      </div>
    );
  }
}
function debounce(fn, ms) {
  let timeoutId
  return function () {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      fn.apply(this, arguments)
    }, ms)
  }
}

export default Answersheet;
